import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import { ILibraryDocument } from '@/pages/Library/libraryDocuments.types.ts'
import { useLayoutEffect, useRef, useState } from 'react'
import { IOption } from '@/types/global.ts'
import libraryDocumentsApi from '@/pages/Library/libraryDocuments.api.ts'
import svgMethods from '@/pages/Dashboards/Charts/SVGChart/svg.methods.ts'
import eventBus from '@/services/eventBus'

interface IProps {
  documentId: ILibraryDocument['id']
  open: boolean
}

const useSVGPreview = (props: IProps) => {
  const { wait, loading: imageLoading } = useHttpLoader(true)

  const imageContainer = useRef<HTMLDivElement>()

  const [textOptions, setTextOptions] = useState<IOption<string>[]>([])
  const [nodeOptions, setNodeOptions] = useState<IOption<string>[]>([])

  /* при выборе изображения пользователем показываем его предпросмотр */
  useLayoutEffect(() => {
    const div = imageContainer.current
    if (!div) return

    if (!props.documentId) {
      div.innerHTML = null
      return
    }

    wait(libraryDocumentsApi.rawDocument(props.documentId, 'doc.svg'), (resp) => {
      if (resp.status === 'error') return

      const src = resp.body
      div.innerHTML = src
      const svg = div.querySelector('svg')
      if (!svg) return

      svgMethods.fitSVG(svg, 355, 300)
      const { all, text, lastIncorrectId } = svgMethods.findNodes(svg)

      if (lastIncorrectId) {
        const errMessage = `Обнаружен id, не являющийся валидным селектором: "${lastIncorrectId}"`
        return eventBus.pub('alert.request', { type: 'warning', title: 'Предупреждение', description: errMessage })
      }

      setTextOptions(text.map((t) => ({ value: t, title: t })))
      setNodeOptions(all.map((n) => ({ value: n, title: n })))
    })
  }, [props.documentId, props.open])

  return {
    imageContainer,
    imageLoading,
    parsedData: {
      textOptions,
      nodeOptions,
    },
  }
}

export default useSVGPreview
